//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<template>
  <div class='content-wrapper'>
    <p style="font-size:16px;">Новости</p>
      <entity-manager :data="news" :options="newsEntityManagerOptions" style="padding-top: 20px;">
        <template slot="dataItemFieldTableView" scope="viewProps">
          <span v-if="viewProps.column.field == 'createdAt'">
            {{viewProps.dataRow.val[viewProps.column.field] | formatDate}}
          </span>
          <span v-else-if="viewProps.column.field == 'author'">
            {{users[viewProps.dataRow.val[viewProps.column.field]].Name}}
          </span>
          <span v-else-if="(viewProps.column.field == 'topical') || (viewProps.column.field == 'publish')">
            {{viewProps.dataRow.val[viewProps.column.field] === true ? 'Да' : 'Нет'}}
          </span>
          <span v-else>
            {{viewProps.dataRow.val[viewProps.column.field]}}
        </span>
        </template>

        <template slot="dataItemFieldEditView" scope="viewProps">
          <span v-if="viewProps.fieldKey == 'name'">
            <Input v-model="viewProps.editingDataRow.val[viewProps.fieldKey]" placeholder="Заглавие новости" style="width:100%"></Input>
          </span>
          <div class="EDT5" v-else-if="viewProps.fieldKey == 'body'">
            <!--Input v-model="viewProps.editingDataRow.val[viewProps.fieldKey]" type="textarea" :rows="10" placeholder="Новость" style="width:100%"></Input-->
            <!--vue-ckeditor v-model="viewProps.editingDataRow.val[viewProps.fieldKey]" :config2="htmlEditorConfig" /-->
            <!--vue-editor :id="'editor' + viewProps.editingDataRow.val['id']" v-model="viewProps.editingDataRow.val[viewProps.fieldKey]" :editorToolbar="htmlEditorToolbarOptions" style="height:350px"/-->
            <vue-html5-editor :content="viewProps.editingDataRow.val[viewProps.fieldKey]" height2="350" @change="function(val){viewProps.editingDataRow.val[viewProps.fieldKey] = val}"></vue-html5-editor>
          </div>
          <span v-else-if="viewProps.fieldKey == 'author'">
            <Select v-model="viewProps.editingDataRow.val[viewProps.fieldKey]" filterable placeholder="Выберите автора" size2="large">
              <Option v-if="item != null" v-for="item in users" :value="item.id" :key="item.id">{{item.Name}}</Option>
            </Select>
          </span>
          <span v-else-if="(viewProps.fieldKey == 'topical') || (viewProps.fieldKey == 'publish')">
            <Checkbox v-model="viewProps.editingDataRow.val[viewProps.fieldKey]" size="small" style="padding-bottom:5px;"></Checkbox>
          </span>
          <span v-else-if="(viewProps.fieldKey == 'updatedAt') || (viewProps.fieldKey == 'createdAt')">
            <DatePicker v-model="viewProps.editingDataRow.val[viewProps.fieldKey]" type="datetime" placeholder="Выберите дату и время" style="width:100%"></DatePicker>
          </span>
          <span v-else>
            <span v-if="(viewProps.editingDataRow.val[viewProps.fieldKey] == null) || (viewProps.editingDataRow.val[viewProps.fieldKey] === '')">&nbsp;</span>
            {{viewProps.editingDataRow.val[viewProps.fieldKey]}}
          </span>
        </template>
      </entity-manager>
  </div>
</template>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<script>
// import Vue from 'Vue'
import { mapGetters } from 'vuex'

// import async from 'async'

import restResource from '@/technical/restResource'
import serverErrorHandling from '@/technical/serverErrorHandling'

import EntityManager from '@/technical/components/EntityManager'

// import Editor from '@tinymce/tinymce-vue'
// import VueCkeditor from 'vue-ckeditor'
// import VueCkeditor from 'vue-ckeditor2'
// import { VueEditor } from 'vue2-editor'
import VueHtml5EditorModule from 'vue-html5-editor'
// help: all options are here: https://github.com/PeakTai/vue-html5-editor
const VueHtml5Editor = new VueHtml5EditorModule({
  visibleModules: [
    'text',
    'color',
    'font',
    'align',
    'list',
    'link',
    'unlink',
    // 'tabulation',
    'image',
    'hr',
    'eraser',
    'undo'
  ]
})

export default {
  data () {
    return {
      users: [],
      news: [],
      htmlEditorToolbarOptions: [
        // [{'header': [1, 2, 3, 4, 5, 6, false]}],
        [{'size': ['huge', 'large', false, 'small']}],
        [{'color': []}, {'background': []}],
        ['bold', 'italic', 'underline', 'strike'],
        [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],

        [{'list': 'ordered'}, {'list': 'bullet'}, {'list': 'check'}],
        [{'indent': '-1'}, {'indent': '+1'}],

        ['blockquote'],
        ['clean']
      ],
      newsEntityManagerOptions: {
        tableColumns: [
          {title: 'id', width: '40px', field: 'id'},
          {title: 'Заголовок', width: '', field: 'name'},
          {title: 'Автор', width: '180px', field: 'author'},
          {title: 'Дата', width: '90px', field: 'createdAt'},
          {title: 'Топ', width: '40px', field: 'topical'},
          {title: 'Пуб', width: '40px', field: 'publish'}
        ],
        editorFields: {author: 'Автор', name: 'Заголовок', topical: 'Показывать на главной', publish: 'Публиковать', body: 'Новость', createdAt: 'Дата публикации', updatedAt: 'Дата изменений', id: 'id'},
        newEmptyEntity: function (thisRef) {
          let result = restResource(thisRef.appSettings.server.host + thisRef.appSettings.server.newsResource)
          result.val = {}
          result.val.author = thisRef.activeUser.id
          result.val.name = ''
          result.val.topical = true
          result.val.publish = true
          result.val.body = ''
          return result
        },
        commonDataReloadOptions: {news: true}
      }
    }
  },
  computed: {
    ...mapGetters([
      'appSettings',
      'activeUser',
      'i18n'
    ])
  },
  components: { EntityManager, VueHtml5Editor },
  created: function () {
    var thisRef = this

    // newsAcceptancesResource.query({'where': '{"refToUser":[' + this.activeUser.id + ']}', 'populate': '[refToNews]', 'sort': 'refToNews asc'})

    // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! это надо выносить в общий компонент читки статических данных с сервера и занесение их в store.CommonData
    var users = []
    var userResource = restResource(thisRef.appSettings.server.host + thisRef.appSettings.server.userResource)
    userResource.query()
    .then(function (response) {
      if (response.data == null) return serverErrorHandling('что-то не так', thisRef)
      // users[0] = {Name: '- Выберите автора -', id: 0}
      for (var itemIndx = 0; itemIndx < response.data.length; itemIndx++) {
        users[response.data[itemIndx].id] = response.data[itemIndx]
      }
      thisRef.users = users

      var news = []
      var newsResource = restResource(thisRef.appSettings.server.host + thisRef.appSettings.server.newsResource)
      newsResource.query({sort: 'createdAt desc'})
      .then(function (response) {
        if (response.data == null) return serverErrorHandling('что-то не так', thisRef)
        for (var itemIndx = 0; itemIndx < response.data.length; itemIndx++) {
          var oneNewsResource = restResource(thisRef.appSettings.server.host + thisRef.appSettings.server.newsResource)
          oneNewsResource.val = response.data[itemIndx]
          news.push(oneNewsResource)
        }
        thisRef.news = news
      })
      .catch((error) => serverErrorHandling(error, thisRef))
    })
    .catch((error) => serverErrorHandling(error, thisRef))
  },
  methods: {
  }
}
</script>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style scoped>
.content-wrapper{
  margin: 0px 0px 0px 0px; /* margin: 25px 20px 50px 20px; */
  padding: 20px;
  background: #fff; height: 100%; /* если цвет отличный от стандартной серой подложики для content или убираем серые margins, то чтобы серый прикрыть надо height=100% */
  font-family: "Roboto Light", sans-serif;
  font-size: 13px;
}
</style>

<style>
/* управляем классом внутри vue-html5-editor */
.vue-html5-editor-content{
  padding: 10px 10px 10px 10px;
  background: #fff;
}
/* ul {
  margin-left: 17px;
  padding-left: 10px;
  list-style-type: disc;
}
ol {
  margin-left: 24px;
  padding-left: 0px;
  list-style-type: decimal;
} */
/* Ломаем MCE Warning about Trial */
/*.mce-notification-warning {
  display: none!important;
}*/
/*[id^=mceu_] {
  display: none!important;
}*/
</style>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// News.vue?66f53d37